import React from "react";

import { ZoomMtg } from "@zoom/meetingsdk";
import { findSignature } from "../api/system-config-api";

ZoomMtg.preLoadWasm();
ZoomMtg.prepareWebSDK();

function Zoom() {
  const KJUR = require("jsrsasign");
  const [meetingId, setMeetingId] = React.useState();
  const [passcode, setPasscode] = React.useState();
  const [fullName, setFullname] = React.useState();
  const [signature, setSignature] = React.useState();
  const [key, setKey] = React.useState();

  const queryParameters = new URLSearchParams(window.location.search);

  var userEmail = "";
  var registrantToken = "";
  var zakToken = "";
  var leaveUrl = "https://zoom.plusliveth.com";

  const loadData = async () => {
    let meetingId = "";
    let passcode = "";
    let fullName = "";

    if (queryParameters.get("meetingId")) {
      meetingId = queryParameters.get("meetingId");
      setMeetingId(meetingId);
    }

    if (queryParameters.get("passcode")) {
      passcode = queryParameters.get("passcode");
      setPasscode(passcode);
    }

    if (queryParameters.get("username")) {
      fullName = queryParameters.get("username");
      setFullname(fullName ? fullName : "Guest");
    }

    let data = await findSignature(meetingId);
    setSignature(data.signature);
    setKey(data.key);
  };

  React.useEffect(() => {
    loadData();
  }, []);

  function startMeeting() {
    document.getElementById("zmmtg-root").style.display = "block";

    ZoomMtg.init({
      leaveUrl: leaveUrl,
      meetingInfo: ["topic", "host"],
      disableInvite: true,
      success: (success) => {
        console.log(success);
        console.log(signature, key, meetingId, passcode, fullName);

        ZoomMtg.join({
          signature: signature,
          sdkKey: key,
          meetingNumber: meetingId,
          passWord: passcode,
          userName: fullName,
          userEmail: userEmail,
          tk: registrantToken,
          zak: zakToken,
          success: (success) => {
            console.log(success);
          },
          error: (error) => {
            console.log(error);
          },
        });
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  return (
    <div className="App">
      <main>
        <h1>PLUSLIVE x ZOOM</h1>
        {meetingId && passcode && signature && key && (
          <button onClick={(e) => startMeeting()}>Join Meeting</button>
        )}
      </main>
    </div>
  );
}

export default Zoom;
